import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()(() => ({
  partnerStep: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 70,
    paddingBottom: '36px',
    marginBottom: '36px',
    '&:last-child': {
      marginBottom: 0,
      paddingBottom: 0,
    },
    '& a': {
      color: '#080808',
      textDecoration: 'underline !important',
    },
  },
}));
